class MFRBlogCarousel {
    constructor( i, e, args ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            dots: ".flickity-page-dots .dot",
            blogTitle: ".blog-card__title"
        }

        this.args = args;

        this.options = {
            contain: true,
            wrapAround: false,
            autoPlay: 3000,
            prevNextButtons: false,
            initialIndex: 2,
            on: {
                ready: () => {
                    this.initCarouselEvents();
                }
            }
        }

        if( args && args.flickityOptions ) this.replaceOptions( args.flickityOptions );
        
        this.init();
    }

    init() {
        this.$blogTitle = this.$element.find( this.selectors.blogTitle );
        this.initMatchHeight();
        
        $( window ).on( "resize", this.initMatchHeight.bind( this ) );

        if( $( window ).width() <= 639 ) {
            this.options["cellAlign"] = "center";
            this.options["contain"] = false;
        }
        this.$element.flickity( this.options );

        if( this.args && this.args.navButtons ) this.initCustomNav();
    }

    initCarouselEvents() {
        this.__handleSliderChange();
        this.$element.on( "change.flickity", this.__handleSliderChange.bind( this ) );
    }

    __handleSliderChange(e, i) {
        const selected = this.$element.find( ".flickity-page-dots .dot.is-selected" );
        const beforeSelected = selected.prev( ".dot" );
        const afterSelected = selected.next( ".dot" );
        const alongsideClass = "alongside-selected";
        const dots = this.$element.find( this.selectors.dots );

        dots.removeClass( alongsideClass );

        beforeSelected.addClass( alongsideClass );
        afterSelected.addClass( alongsideClass );

        this.updateNav( i );
    }

    replaceOptions( options ) {
        $.each( options, ( i, e ) => {
            this.options[i] = e;
        } )
    }

    initCustomNav() {
        this.$element.closest( "section" ).find( `${ this.args.navButtons }.previous` ).on( "click", () => this.$element.flickity( "previous" ) )
        this.$element.closest( "section" ).find( `${ this.args.navButtons }.next` ).on( "click", () => this.$element.flickity( "next" ) )
    }

    updateNav(i) {
        if( i === undefined || !this.args || !this.$element.closest( "section" ).find( this.args.navButtons ).length ) return;
        this.$element.closest( "section" ).find( `${ this.args.navButtons }` ).removeClass( "disabled" );
        if( i == 0 ) this.$element.closest( "section" ).find( `${ this.args.navButtons }.previous` ).addClass( "disabled" );
     
        if( i == this.$element.data( "flickity" ).cells.length - 1 ) this.$element.closest( "section" ).find( `${ this.args.navButtons }.next` ).addClass( "disabled" );
    }

    initMatchHeight() {
        this.$blogTitle.css( "height", "" );
        const maxHeight = Math.max.apply(null, this.$blogTitle.map(function (){
            return $(this).outerHeight();
        }).get());
        this.$blogTitle.height( maxHeight );

        if( this.$element.data( "flickity" ) )
            this.$element.flickity( "resize" );
    }
}